import React from 'react'
import mediumIcon from '../images/medium.png'
import youtubeIcon from '../images/youtube.png'
import SocialIcon from './SocialIcon.js'

class DesignProjectCard extends React.Component {
    render() {
        const design = this.props.node
        return <div className="designProjectCard">
            <div>
                <h3>{ design.title }</h3>
                <div>{ design.description }</div>
                <a style={{ marginLeft: 'auto' }} href={ design.url } target="_blank"> 
                    { design.url.includes('medium') ? 
                        <SocialIcon src={ mediumIcon } alt="Medium" /> :
                        <SocialIcon src={ youtubeIcon } alt="Youtube" />
                    }
                </a> 
            </div>
                <div style={{ backgroundImage: `url(${design.image})` }} className="designProjectImage" />
        </div>
    }
}

export default DesignProjectCard
